import { DEFAULT_SECURITY_NONCE_PATH } from './constants.ts'

/** Resolve a target page to its HTTP origin; setup also accepts bare hostnames. */
export function securityTargetOrigin(targetUrl: string): string | null {
  const raw = targetUrl.trim()
  if (!raw) return null
  const normalized = /^[a-z][a-z0-9+.-]*:\/\//i.test(raw)
    ? raw
    : `${/^localhost(?::\d+)?(?:[/?#]|$)/i.test(raw) ? 'http' : 'https'}://${raw}`
  try {
    const parsed = new URL(normalized)
    return parsed.protocol === 'http:' || parsed.protocol === 'https:' ? parsed.origin : null
  } catch {
    return null
  }
}

/** Shared by publishing instructions, setup verification, and the live ownership gate. */
export function securityNonceUrl(targetUrl: string, noncePath = DEFAULT_SECURITY_NONCE_PATH): string {
  const origin = securityTargetOrigin(targetUrl)
  return origin ? `${origin}/${noncePath.replace(/^\/+/, '')}` : ''
}
